module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper um-wrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [(_vm.loading) ? _c('el-col', {
    staticClass: "um-loading",
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('p', {
    staticClass: "um-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.module.subscribe.title')) + "\n          "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    staticClass: "um-body",
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h2', {
    staticClass: "um-heading"
  }, [_vm._v("Connect UniMicro (Certificate)")]), _vm._v(" "), _c('p', {
    staticClass: "um-text"
  }, [_vm._v("\n          To connect your UniMicro account with Kundan, follow the steps below.\n          Your company’s "), _c('b', [_vm._v("Organization Number (Org.nr)")]), _vm._v(" is already stored in your organization details.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "um-section"
  }, [_c('p', {
    staticClass: "um-subtitle"
  }, [_vm._v("Log in to UniMicro")]), _vm._v(" "), _c('a', {
    staticClass: "um-link",
    attrs: {
      "href": "https://test.unimicro.no",
      "target": "_blank"
    }
  }, [_vm._v("\n            https://test.unimicro.no\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "um-section"
  }, [_c('p', {
    staticClass: "um-subtitle"
  }, [_vm._v("Enable Kundan Integration")]), _vm._v(" "), _c('ol', {
    staticClass: "um-steps"
  }, [_c('li', [_vm._v("Open your "), _c('b', [_vm._v("Uni Economy")]), _vm._v(" dashboard.")]), _vm._v(" "), _c('li', [_vm._v("Go to "), _c('b', [_vm._v("Markedsplass → Integrasjoner")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Find "), _c('b', [_vm._v("Kundan")]), _vm._v(" in the list of available integrations.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Les mer")]), _vm._v(" on the Kundan integration card.")]), _vm._v(" "), _c('li', [_vm._v("Click "), _c('b', [_vm._v("Aktiver")]), _vm._v(" to enable the Kundan integration.")])])]), _vm._v(" "), _c('div', {
    staticClass: "um-section"
  }, [_c('p', {
    staticClass: "um-subtitle"
  }, [_vm._v("Once you choose your UniMicro environment, Kundan will:")]), _vm._v(" "), _c('ul', {
    staticClass: "um-list"
  }, [_c('li', [_vm._v("Authenticate using our UniMicro certificate")]), _vm._v(" "), _c('li', [_vm._v("Generate a secure access token")]), _vm._v(" "), _c('li', [_vm._v("Fetch and match your Company Key")]), _vm._v(" "), _c('li', [_vm._v("Use your stored Org.nr to identify your company")]), _vm._v(" "), _c('li', [_vm._v("Store everything securely in your organization settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "um-section"
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "static.module.unimicro",
      "hasLabel": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "activation-check"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.activationConfirmed),
      callback: function($$v) {
        _vm.activationConfirmed = $$v
      },
      expression: "activationConfirmed"
    }
  }, [_vm._v("\n            I have enabled Kundan inside UniMicro Integrations.\n          ")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "um-footer"
  }, [_c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal(true)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.close')) + "\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "type": "primary",
      "loading": _vm.form.loading,
      "disabled": !_vm.activationConfirmed
    },
    on: {
      "click": _vm.authorize
    }
  }, [_vm._v("\n        Subscribe\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c27bbc7","hasScoped":false}!./src/app/components/unimicroModuleSetup/unimicroModuleSetup.html
// module id = 3052
// module chunks = 1